import { handleException } from 'clients/exception-handling'
import { loadScript } from 'trackers/helper'

export async function initMetaPixel(): Promise<void> {
  const pixelId = import.meta.env.VITE_META_PIXEL_DATASET_ID
  if (!pixelId) return
  if (window.fbq) return

  // Meta Pixel vendor initialization - dynamic function-object hybrid pattern
  // eslint-disable-next-line @typescript-eslint/no-explicit-any -- Meta Pixel SDK uses dynamic function-object hybrid pattern
  const n: any = (window.fbq = function (...args: unknown[]) {
    if (n.callMethod) {
      n.callMethod(...args)
    } else {
      n.queue.push(args)
    }
  })
  if (!window._fbq) window._fbq = n
  n.push = n
  n.loaded = true
  n.version = '2.0'
  n.queue = []

  try {
    await loadScript('https://connect.facebook.net/en_US/fbevents.js')
    window.fbq('init', pixelId)
    window.fbq('track', 'PageView')
  } catch (error) {
    handleException(error, {
      operation: 'tracker.meta.initialize',
      disposition: 'recovered',
      reason: 'Application continues without optional analytics.',
    })
  }
}
